import type { ColumnConfig } from '@/components/configure-columns-dialog';

// Default column configuration for the Audit Exceptions screen
export const DEFAULT_EXCEPTION_COLUMNS: ColumnConfig[] = [
  // Default columns (visible by default)
  { id: 'severity', label: 'Severity', visible: true, order: 0, group: 'default' },
  { id: 'asset', label: 'Asset', visible: true, order: 1, group: 'default' },
  { id: 'exceptionType', label: 'Exception Type', visible: true, order: 2, group: 'default' },
  { id: 'description', label: 'Description', visible: true, order: 3, group: 'default' },
  { id: 'status', label: 'Status', visible: true, order: 4, group: 'default' },
  { id: 'reportedBy', label: 'Reported By', visible: true, order: 5, group: 'default' },
  { id: 'reportedDate', label: 'Reported Date', visible: true, order: 6, group: 'default' },
  
  // Optional columns (hidden by default)
  { id: 'assignedTo', label: 'Assigned To', visible: false, order: 7, group: 'optional' },
  { id: 'resolvedDate', label: 'Resolved Date', visible: false, order: 8, group: 'optional' },
  { id: 'resolvedBy', label: 'Resolved By', visible: false, order: 9, group: 'optional' },
];

export const EXCEPTION_COLUMNS_STORAGE_KEY = 'audit-exceptions-columns-config';
